// extracted by mini-css-extract-plugin
export var control = "SegmentedControl-module--control--25362";
export var indicator = "SegmentedControl-module--indicator--8dee8";
export var label = "SegmentedControl-module--label--f3f21";
export var root = "SegmentedControl-module--root--4370b";